const DEBUG_ALLOWED_EMAILS = new Set([
  'mareevp0710@gmail.com',
  'sonyamorderer@gmail.com',
]);

export const canAccessDebug = (email) => {
  const normalized = String(email ?? '').trim().toLowerCase();
  return Boolean(normalized) && DEBUG_ALLOWED_EMAILS.has(normalized);
};
